<template>
    <div>
        <el-form-item label="Typ"
                      :error="errors.widget_type">
            <el-select v-model="form.widget_type"
                       placeholder="Wybierz typ">
                <el-option
                        v-for="item in types"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                </el-option>
            </el-select>
        </el-form-item>
        <div v-if="form.widget_type === 'ticket'">
            <el-form-item label="Bilet"
                          :error="errors.ticket">
                <el-select v-model="form.ticket"
                           placeholder="Wybierz bilet">
                    <el-option
                            v-for="item in tickets"
                            :key="item.id"
                            :label="item.name_pl"
                            :value="item.id">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="Sold out"
                          :error="errors.single_ticket_sold_out">
                <el-switch v-model="form.single_ticket_sold_out"/>
            </el-form-item>
        </div>
        <div v-if="form.widget_type === 'period'">
            <el-form-item label="Okres"
                          :error="errors.period">
                <el-select v-model="form.period"
                           placeholder="Wybierz okres">
                    <el-option
                            v-for="item in periods"
                            :key="item.id"
                            :label="item.name_pl"
                            :value="item.id">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="Domyślnie rozwinięty">
                <el-switch v-model="form.expanded_at_start"/>
            </el-form-item>
            <el-form-item label="Kolor tła"
                          :error="errors['bg_color']">
                <el-color-picker v-model="form.bg_color"/>
            </el-form-item>
            <el-form-item label="Kolor tekstu"
                          :error="errors['text_color']">
                <el-color-picker v-model="form.text_color"/>
            </el-form-item>
            <el-form-item label="Program">
                <link-component v-model="form.program"
                                :errors="errors['program']">
                </link-component>
            </el-form-item>
        </div>
    </div>
</template>
<script>
    import {Ticket, Period} from '@/api/';

    export default {
        props: ['form', 'errors'],
        data () {
            return {
                periods: [],
                tickets: [],
                types: [
                    {label: 'Pojedynczy bilet', value: 'ticket'},
                    {label: 'Okres sprzedaży', value: 'period'},
                ]
            }
        },
        mounted () {
            this.fetchData()
        },
        methods: {
            fetchData () {
                Period.fetch().then(response => {
                    this.periods = response.data
                })
                Ticket.fetch().then(response => {
                    this.tickets = response.data
                })
            }
        }
    }
</script>
<style lang="scss" scoped>
</style>


// WEBPACK FOOTER //
// TicketsWidget.vue?681089f0